import { isNotNullOrEmptyString, sanitizeValueOr } from '../../shared/utils/functions';
import { SpaceCardDetails } from '../../stacking-plan-container/actions-toolbar/settings/settings.model';
import { EDPSpaceInfo, SuiteType } from '../../stacking-plan-container/floor-container/floor/item/item.model';
import { MappedLov } from '../../stacking-plan.model';
import { AbstractSpaceClass, SpaceClassOptions } from './abstract-space.class';

export class NonRentableSpaceClass extends AbstractSpaceClass {
  spaceClassificationTypeDesc: string;
  spaceClassificationTitle: string;
  nonRentableSize: number;
  nonRentableSizeUomDesc: string;
  notes: string;
  constructor(edpSpaceInfo: EDPSpaceInfo, options?: Partial<SpaceClassOptions>) {
    super(edpSpaceInfo, SuiteType.NonRentable, options);
    const { space_classification_type_desc, non_rentable_size, non_rentable_size_uom_desc, notes } =
      edpSpaceInfo.non_rentable_space;
    this.spaceClassificationTypeDesc = space_classification_type_desc;
    this.nonRentableSize = non_rentable_size;
    this.nonRentableSizeUomDesc = non_rentable_size_uom_desc;
    this.notes = notes;
  }

  getAreaSpace(): number {
    return this.nonRentableSize;
  }

  getAreaSpaceUOM(): string {
    return this.nonRentableSizeUomDesc;
  }

  enableEditEvent(): boolean {
    return true;
  }

  internalSpaceInfoClone(): Pick<EDPSpaceInfo, 'tenant' | 'lease' | 'availability' | 'non_rentable_space'> {
    return {
      tenant: null,
      lease: null,
      availability: null,
      non_rentable_space: {
        space_classification_type_desc: this.spaceClassificationTypeDesc,
        non_rentable_size: this.nonRentableSize,
        non_rentable_size_uom_desc: this.nonRentableSizeUomDesc,
        notes: this.notes,
      },
    };
  }

  toString(options?: { detailsToDisplay: SpaceCardDetails; mappedUomLov?: MappedLov }): string {
    const {
      detailsToDisplay: { spaceSize: isSpaceSizeRequired, suiteNumber: isSuiteNumberRequired },
      mappedUomLov,
    } = options;
    const mappedTitleName =
      isNotNullOrEmptyString(this.spaceClassificationTypeDesc) && mappedUomLov[this.spaceClassificationTypeDesc]
        ? mappedUomLov[this.spaceClassificationTypeDesc]
        : this.spaceClassificationTypeDesc;
    const title = sanitizeValueOr(AbstractSpaceClass.unknown, mappedTitleName);
    const spaceSize = sanitizeValueOr(AbstractSpaceClass.unknown, this.generateFloorSpace(mappedUomLov || null));
    let stringResult = `${title}${isSpaceSizeRequired && spaceSize != null ? `\n${spaceSize}` : ''}`;
    if (isSuiteNumberRequired) {
      stringResult = stringResult + `${`\n${this.getSuiteNumber(this.options)}`}`;
    }
    return stringResult;
  }
}
